import { CancelledOrders } from "../../models/orders/order-list-model";
import * as XLSX from 'xlsx';

export const CancelledorderExport = (cancelledOrderList: CancelledOrders[]) => {
    const orderData = CancelledWiseData(cancelledOrderList);
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(orderData);

    XLSX.utils.book_append_sheet(wb, ws, 'CancelledOrders');
    XLSX.writeFile(wb, 'CancelledOrdersExport.xlsx');
}

const CancelledWiseData = (cancelledOrderList: CancelledOrders[]) => {
    var flatData: any = [];
    cancelledOrderList?.forEach((order) => {                
        flatData.push({
            'Order ID': order.orderID,
            'Customer Phone Number': order.primaryContactNbr,
            'Customer Name': order.userName,
            'Cancellation Date': order.modifiedDate ? new Date(order.modifiedDate).toLocaleDateString() : '',
            'Cancelled By User': order.canceledUserName,
            'Cancelled By Phone': order.canceledPrimaryContactNbr
        });        
    });
    return flatData;
}